import { ReactNode } from "react";

export const joinComponents = (list: ReactNode[], mergeWith: ReactNode) => {
    return list.flatMap((item, ix) => [item, ...(ix === list.length - 1 ? [] : [mergeWith])]);
};
